/** @module ProductSpec/SizeChart/AggregateSelectedSizes */
define([
	"dojo/_base/declare",
	"csi/heading/AggregateController",
	"csi/xml",
	"csi/xml/Query"
], function(declare, AggregateController, xml, Query) {

	return declare(AggregateController, {
		/**
		 * @override
		 * Weed out any inactive sizes - those are the ones that belong to any inactive SizeChartSubSizeRanges
		 */
		_getFixedFilters: function() {
			const q = new Query();
			const revision = this.getNode();

			this.m_cache.getNodes(revision.SizeChartSubSizeRanges).forEach((ssr) => {
				if (!ssr.Active) {
					ssr.Sizes.forEach((s) => {
						q.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, s);
					});
				}
			});

			return q.getElements();
		}
	});
});
